module.exports = __webpack_public_path__ + "img/p-3-2-1.5908bc00.jpg";